import { LitElement, html } from 'lit';
import { TagKey } from '@cof/tag-catalog-fs-personal-mfe';
import { DebugService } from '../../../shared/services/debug.service.js';
import { style } from './step-communication.style.js';
import { ApplicationService } from '../../../services/application.service.js';
import './phone/phone.component.js';
import './email/email.component.js';
import { globalStyle } from '../../../global-styles.style.js';
import { REFI_PERSONAL_CONST } from '../../../shared/constants/app.constants.js';
import { validateForm } from '../../../shared/decorators/validate-form.decorator.js';
import { stratum } from '../../../../constants/stratum.js';

class RefiStepNameComponent extends LitElement {
  constructor() {
    super();
    this.debug = new DebugService('RefiStepCommunication');
    this.validity = {};
    this.useTextOptIn = false;
    this.childIds = {
      email: 'email-input',
      phone: 'phone-input',
      textOptIn: 'text-opt-in-input',
    };
    this.childIds = {
      email: 'email-input',
      phone: 'phone-input',
      textOptIn: 'text-opt-in-input',
    };
  }

  static properties = {
    isPrefill: { type: Boolean, attribute: 'is-prefill' },
    isPrimary: { type: Boolean, attribute: 'is-primary', reflect: true },
  };

  static styles = [style, globalStyle];

  get applicant() {
    return this.isPrimary
      ? ApplicationService.Application.primaryApplicant
      : ApplicationService.Application.coApplicant;
  }

  connectedCallback() {
    super.connectedCallback();
    this.coAppPrefix = this.isPrimary ? '' : 'co-';
    this.useTextOptIn =
      this.isPrimary &&
      ApplicationService.Application.profileType ===
        REFI_PERSONAL_CONST.FINANCIAL;

    stratum.publishTag(
      this.isPrimary
        ? TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_COMMUNICATION
        : TagKey.PAGE_VIEW_COAF_REFI_PREQUALIFY_PERSONAL_CO_APP_COMMUNICATION
    );
  }

  render() {
    return html`
      <form
        id="step-communication-form"
        class="step-communication-form"
        @submit="${this.onSubmit}"
        novalidate
      >
        <refi-heading>
          ${this.isPrimary
            ? html`${this.isPrefill
                ? html`Thanks ${this.applicant.firstName}! Please confirm your
                  contact information.`
                : html`Nice to meet you ${this.applicant.firstName}! How can we
                  reach you?`}`
            : html` Now let us know how to communicate with your co-applicant,
              ${this.applicant.firstName}`}
        </refi-heading>

        <refi-personal-email
          id="${this.childIds.email}"
          @validity="${this.updateValidity}"
          ?is-primary="${this.isPrimary}"
          ?is-prefill="${this.isPrefill}"
        ></refi-personal-email>
        <refi-personal-phone
          id="${this.childIds.phone}"
          @validity="${this.updateValidity}"
          ?is-primary="${this.isPrimary}"
          ?text-opt-in="${this.useTextOptIn}"
          opt-in-child-id="${this.childIds.textOptIn}"
        ></refi-personal-phone>

        <div class="button-container">
          <fs-button class="fs-button next-button" variant="primary"
            ><span>${!this.isPrefill ? 'Next' : 'Confirm'}</span>
          </fs-button>
        </div>
      </form>
    `;
  }

  updateValidity(ev) {
    this.validity[ev.detail.name] = ev.detail.isValid;
  }

  @validateForm()
  onSubmit() {
    this.inputChildren = {
      email: this.shadowRoot.getElementById(this.childIds.email),
      phone: this.useTextOptIn
        ? this.shadowRoot
            .getElementById(this.childIds.phone)
            .shadowRoot.getElementById(this.childIds.textOptIn)
        : this.shadowRoot.getElementById(this.childIds.phone),
    };

    this.runChildrenBusinessChecks();

    stratum.publishTag(TagKey.PERSONAL_COMMUNICATION_SMS_OPT_SELECTION, {
      replacements: { value: this.applicant.smsOptIn },
    });
    let valid = true;
    this.debug.log(this.validity);
    Object.values(this.validity).forEach((validityValue) => {
      if (!validityValue) {
        valid = false;
      }
    });

    if (valid) {
      this.oldApplicantInfo = structuredClone(this.applicant);

      const updatedApplicant = {
        ...this.applicant,
      };

      Object.values(this.inputChildren).forEach((child) => {
        Object.keys(child.values).forEach((field) => {
          updatedApplicant[field] = child.values[field];
        });
      });

      updatedApplicant.confirmEmailAddress = updatedApplicant.emailAddress;

      // Update ApplicationService with new values
      if (this.isPrimary) {
        ApplicationService.Application = {
          ...ApplicationService.Application,
          primaryApplicant: updatedApplicant,
        };
      } else {
        ApplicationService.Application = {
          ...ApplicationService.Application,
          coApplicant: updatedApplicant,
        };
      }

      this.tagFieldChangesOnSubmit();
      this.debug.log('valid', ApplicationService.Application);
      this.dispatchEvent(new CustomEvent('next-step'));
    }
  }

  tagFieldChangesOnSubmit() {
    Object.keys(this.applicant).forEach((field) => {
      if (
        typeof this.applicant[field] !== 'object' &&
        this.applicant[field] !== this.oldApplicantInfo[field]
      ) {
        this.debug.log(`${this.coAppPrefix}${field}`);
        stratum.publishTag(TagKey.PQ_TEXT_INPUT_FIELD_CHANGED_FIELD, {
          replacements: {
            value: `${this.coAppPrefix}${field}`,
          },
        });
      }
    });
  }

  runChildrenBusinessChecks() {
    this.inputChildren.email.runBusinessChecks();
  }
}

customElements.define('refi-step-communication', RefiStepNameComponent);
